import { useEffect, useRef } from 'react';
import { MessageBubble } from './MessageBubble.jsx';

/** Live transcript of a voice session (user + assistant turns). */
export function TranscriptPanel({ transcript }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [transcript]);

  return (
    <div ref={ref} className="flex-1 overflow-y-auto p-5">
      {(!transcript || transcript.length === 0) ? (
        <div className="flex h-full items-center justify-center">
          <p className="max-w-sm text-center text-sm text-ink-muted">
            Avvia la sessione e parla: qui compaiono in tempo reale le tue parole e le risposte dell'assistente.
          </p>
        </div>
      ) : (
        <ul className="flex flex-col gap-4">
          {transcript.map((m) => (
            <li key={m.id}>
              <MessageBubble role={m.role} content={m.text} streaming={m.role === 'assistant' && !m.final} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
